import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';

type UnitProps = {
  unitNumber: number;
  title: string;
  subTitle: string;
};

export default function Unit({ unitNumber, title, subTitle }: UnitProps) {
  return (
    <Container className='mb-4 flex flex-1 grow items-center gap-2 md:grid-cols-4 md:flex-col md:items-start'>
      <Container className='h-10 w-10 rounded-full bg-[#F9FAFC]' center>
        <Text type={TEXT_TYPE.SPAN} className='text-sm leading-6 text-[#424244]'>
          {unitNumber}
        </Text>
      </Container>
      <Container className='flex flex-col text-start'>
        <Text type={TEXT_TYPE.SPAN} className='text-xs font-[200] leading-6 text-[#5B5C60]'>
          {title}
        </Text>
        <Text
          type={TEXT_TYPE.SPAN}
          className='text-sm font-medium leading-6 tracking-tighter text-[#424244]'
        >
          {subTitle}
        </Text>
      </Container>
    </Container>
  );
}
